<template>
  <el-input
    ref="inputRef"
    :model-value="props.modelValue"
    :class="props.transparent ? 'is-transparent' : ''"
    :type="props.search ? 'search' : props.type"
    :name="props.name"
    :placeholder="props.placeholder"
    :autocomplete="props.autocomplete"
    :maxlength="props.maxlength"
    :show-word-limit="Boolean(props.maxlength)"
    :disabled="props.disabled"
    @update:model-value="(payload) => emit('update:modelValue', payload)"
  >
    <template #prefix>
      <slot
        v-if="$slots.prefix"
        name="prefix"
      />

      <Icon
        v-else-if="props.search"
        name="search-sm"
        class="w-5 h-5 text-gray-500 mr-2 flex-shrink-0"
      />
    </template>
  </el-input>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'text',
  },
  name: {
    type: String,
    default: undefined,
  },
  transparent: {
    type: Boolean,
    default: false,
  },
  search: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: undefined,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  autocomplete: {
    type: String,
    default: undefined,
  },
  maxlength: {
    type: Number,
    default: undefined,
  },
});

const emit = defineEmits(['update:modelValue']);

// Refs
const inputRef = ref(null);

defineExpose({
  inputRef,
});
</script>
